import React from 'react';
import styled from 'styled-components';
import { useApiKey } from '../context/ApiKeyContext';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
  text-align: center;
`;

const Title = styled.h2`
  color: #0d9488;
  margin-bottom: 1rem;
`;

const Message = styled.p`
  color: #555;
  margin-bottom: 2rem;
  line-height: 1.6;
`;

const Button = styled.button`
  padding: 0.85rem 1.5rem;
  background-color: #0d9488;
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #0f766e;
  }
`;

// Shown when the owner's trial key has run out of credits. Sends the user to
// the bring-your-own-key flow.
const OutOfCreditsCard = () => {
  const { endTrial } = useApiKey();

  return (
    <Container>
      <Title>Out of tokens</Title>
      <Message>
        Sorry, the owner is out of tokens. Please use your own API key to keep practicing.
      </Message>
      <Button onClick={endTrial}>Use your own API key</Button>
    </Container>
  );
};

export default OutOfCreditsCard;
